module.exports = __webpack_public_path__ + "static/img/project1.ccbfe92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project1.jpg
// module id = 742
// module chunks = 1